import { render } from "./CollapseComp.vue?vue&type=template&id=1975d0ed&scoped=true"
import script from "./CollapseComp.vue?vue&type=script&lang=js"
export * from "./CollapseComp.vue?vue&type=script&lang=js"

import "./CollapseComp.vue?vue&type=style&index=0&id=1975d0ed&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\Stella-Maris-53-VueJSOld\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1975d0ed"]])

export default __exports__